import history from './HistoryService';
import urlUtil from '../util/url/urlUtil';
import { cloneOnlyProperValues } from '../util/object/objectUtil';

export interface AppSpecifiedRoutingService {
    navigateToLastVisitedUrl?: () => void;
    getUrlRelevantPropsFromContext?: () => {};
    [propName: string]: (args: any) => any;

}

let appSpecifiedRoutingService: AppSpecifiedRoutingService;
const commonRoutingService = {
    setNewUrlSearchString(newParams: any, silent?: boolean): void {
        const queryParams: any = {
            ...urlUtil.parseLocationSearchString(window.location.search),
            ...newParams,
        };
        const paramsToUpdate = cloneOnlyProperValues(queryParams); // This is to remove any params that are set to null or undefined in newParams.
        const queryString: string = urlUtil.buildUrlQueryString(paramsToUpdate);
        const state = silent ? { silent: true } : undefined;
        history.push(`${queryString}`, state);
    },

    buildUrlFromCurrentContext(extraParams?: { [index: string]: any }): string {
        let searchString: string;
        const relevantPropsFromContext = appSpecifiedRoutingService.getUrlRelevantPropsFromContext();
        if (extraParams) {
            searchString = urlUtil.buildUrlQueryString({
                ...relevantPropsFromContext,
                ...extraParams,
            });
        } else {
            searchString = urlUtil.buildUrlQueryString(
                relevantPropsFromContext,
            );
        }

        return `${location.pathname}${searchString}`;
    },
    navigateToLastVisitedUrl() {
        if (appSpecifiedRoutingService.navigateToLastVisitedUrl) {
            appSpecifiedRoutingService.navigateToLastVisitedUrl();
        }
    },
};

export const initializeCommonRoutingService = (appRoutingService: any) => {
    appSpecifiedRoutingService = appRoutingService;
};
export default commonRoutingService;
